// When do you want to achieve this?
import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '⚡',
    title: 'pages.onboarding.goalsTimeline.answer1',
    subtitle: 'pages.onboarding.goalsTimeline.answer1Subtitle',
  },
  {
    emoji: '📅',
    title: 'pages.onboarding.goalsTimeline.answer2',
    subtitle: 'pages.onboarding.goalsTimeline.answer2Subtitle',
  },
  {
    emoji: '🗓️',
    title: 'pages.onboarding.goalsTimeline.answer3',
    subtitle: 'pages.onboarding.goalsTimeline.answer3Subtitle',
  },
  {
    emoji: '📆',
    title: 'pages.onboarding.goalsTimeline.answer4',
    subtitle: 'pages.onboarding.goalsTimeline.answer4Subtitle',
  },
  {
    emoji: '🌿',
    title: 'pages.onboarding.goalsTimeline.answer5',
    subtitle: 'pages.onboarding.goalsTimeline.answer5Subtitle',
  },
]

export default function GoalsTimelinePage() {
  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.goalsTimeline.title"
      subtitle="pages.onboarding.goalsTimeline.subtitle"
    />
  )
}
